import AuthContainer from 'common/components/Layout/AuthLayout/AuthContainer'
import { AuthLayout } from 'common/components/Layout/AuthLayout/AuthLayout'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { ForgotPassComponent } from 'services/auth/forgot-password/ForgotPassComponent'
import { ForgotPasswordInstructions } from 'services/auth/forgot-password/ForgotPasswordInstructions'

const ForgotPassword = () => {
  const [email, setEmail] = useState<string | null>(null)
  const router = useRouter()

  useEffect(() => {
    const { email } = router.query as { email: string }
    setEmail(email)
  }, [router])

  return (
    <AuthContainer>
      <Head>
        <title>Forgot Password</title>
      </Head>
      <AuthLayout>{email ? <ForgotPasswordInstructions email={email} /> : <ForgotPassComponent />}</AuthLayout>
    </AuthContainer>
  )
}
ForgotPassword.getLayout = (page: React.ReactNode | React.ReactNode[]) => page

export default ForgotPassword
